import { render } from "./SliderButtons.vue?vue&type=template&id=342d6989&scoped=true"
import script from "./SliderButtons.vue?vue&type=script&lang=js"
export * from "./SliderButtons.vue?vue&type=script&lang=js"

import "./SliderButtons.vue?vue&type=style&index=0&id=342d6989&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-342d6989"

export default script